"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _form = _interopRequireDefault(require("./form.js"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var AppDefs = window.cccisd.appDefs;
var ProfileUpdateForm = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(ProfileUpdateForm, _React$Component);
  function ProfileUpdateForm() {
    var _this;
    _classCallCheck(this, ProfileUpdateForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ProfileUpdateForm, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: true,
      pawn: {},
      fields: [],
      initialValues: {},
      fieldDefs: [],
      isUsernameEmail: false
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this$props, includePasswordFields, includePawnFields, includeUserFields, includeNotificationFields, pawnHash, pawnId, response, fields, fieldDefs, initialValues, responseUser, emailLabel, usernameLabel, role, showTheseProfileDataFields, roleDef, roleData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$props = _this.props, includePasswordFields = _this$props.includePasswordFields, includePawnFields = _this$props.includePawnFields, includeUserFields = _this$props.includeUserFields, includeNotificationFields = _this$props.includeNotificationFields, pawnHash = _this$props.pawnHash, pawnId = _this$props.pawnId;
            _context.next = 3;
            return _cccisdAxios["default"].get(Boilerplate.route('api.nexus.pawn.show', {
              pawnId: pawnId,
              pawnHash: pawnHash
            }));
          case 3:
            response = _context.sent;
            if (response.data.status !== 'success') {
              _this.setState({
                loading: false
              });
              console.error(response.data.errors);
            }
            fields = [];
            fieldDefs = [];
            initialValues = {};
            responseUser = response.data.data.user || null;
            if (responseUser !== null && includeUserFields) {
              emailLabel = 'Email';
              if (responseUser.isUsernameEmail) {
                _this.setState({
                  isUsernameEmail: true
                });
                emailLabel = 'Email (will also update Username)';
              } else {
                fields.push('username');
                initialValues.username = responseUser.username;
                fieldDefs.push({
                  handle: 'username',
                  label: 'Username',
                  data_type: 'string',
                  disabled: true
                });
              }
              fields.push('first_name');
              fields.push('last_name');
              fields.push('email');
              fields.push('phone');
              initialValues.first_name = responseUser.first_name ? responseUser.first_name : '';
              initialValues.last_name = responseUser.last_name ? responseUser.last_name : '';
              initialValues.email = responseUser.email ? responseUser.email : '';
              initialValues.phone = responseUser.phone ? responseUser.phone : '';
              fieldDefs.push({
                handle: 'first_name',
                label: 'First Name',
                data_type: 'string',
                disabled: responseUser.auth_type === 'ldap' ? true : false
              });
              fieldDefs.push({
                handle: 'last_name',
                label: 'Last Name',
                data_type: 'string',
                disabled: responseUser.auth_type === 'ldap' ? true : false
              });
              fieldDefs.push({
                handle: 'email',
                label: emailLabel,
                data_type: 'string',
                extras: {
                  length: 128
                },
                disabled: responseUser.auth_type === 'ldap' ? true : false
              });
              fieldDefs.push({
                handle: 'phone',
                label: 'Phone',
                data_type: 'string'
              });
            }
            if (responseUser !== null && responseUser.auth_type !== 'ldap' && includePasswordFields) {
              if (!fields.includes('username')) {
                usernameLabel = responseUser.isUsernameEmail ? 'Username / Email' : 'Username';
                fields.push('username');
                initialValues.username = responseUser.username;
                fieldDefs.push({
                  handle: 'username',
                  label: usernameLabel,
                  data_type: 'string',
                  autoComplete: 'username',
                  disabled: true
                });
              }
              fields.push('oldPassword');
              fields.push('password');
              fields.push('repeatPassword');
              initialValues.oldPassword = '';
              initialValues.password = '';
              initialValues.repeatPassword = '';
              fieldDefs.push({
                handle: 'oldPassword',
                label: 'Current Password',
                data_type: 'password',
                autoComplete: 'current-password'
              });
              fieldDefs.push({
                handle: 'password',
                label: 'New Password',
                data_type: 'password',
                autoComplete: 'new-password'
              });
              fieldDefs.push({
                handle: 'repeatPassword',
                label: 'Re-enter New Password',
                data_type: 'password',
                autoComplete: 'new-password'
              });
            }

            // if the props showTheseProfileDataFields is included
            // then show those fields for the specified role for updating
            // otherwise, do not show any pawn data fields for updating profile
            role = Fortress.user.acting.role.handle;
            showTheseProfileDataFields = _this.props.showTheseProfileDataFields && _this.props.showTheseProfileDataFields[role] ? _this.props.showTheseProfileDataFields[role] : [];
            roleDef = AppDefs.pawn.roles.filter(function (item) {
              return item.handle === response.data.data.role.handle;
            });
            if (roleDef.length > 0) {
              roleDef = roleDef[0];
              if (Object.prototype.hasOwnProperty.call(roleDef, 'editableFields')) {
                showTheseProfileDataFields = roleDef.editableFields;
              }
            }
            if (includePawnFields) {
              roleData = response.data.data.role_data;
              response.data.data.role.fields.forEach(function (e) {
                if (showTheseProfileDataFields.includes(e.handle)) {
                  fields.push(e.handle);
                  if (e.data_type === 'boolean') {
                    initialValues[e.handle] = roleData[e.handle] ? true : false;
                  } else {
                    initialValues[e.handle] = roleData[e.handle] ? roleData[e.handle] : '';
                  }
                  fieldDefs.push({
                    handle: e.handle,
                    label: e.label,
                    data_type: e.data_type,
                    values: e.values,
                    extras: e.extras
                  });
                }
              });
            }
            if (includeNotificationFields) {
              fields.push('notifications_subscription');
              fields.push('notification_preference');
              initialValues.notifications_subscription = responseUser.notifications_subscription === 1 ? true : false;
              initialValues.notification_preference = responseUser.notification_preference ? responseUser.notification_preference : 'Email';
              fieldDefs.push({
                handle: 'notifications_subscription',
                label: 'Receive Notifications?',
                data_type: 'boolean'
              });
              fieldDefs.push({
                handle: 'notification_preference',
                label: 'Notification Preference',
                data_type: 'enum',
                values: [{
                  name: 'Email',
                  value: 'Email'
                }, {
                  name: 'Text',
                  value: 'Text'
                }]
              });
            }
            _context.next = 19;
            return _this.setState({
              loading: false,
              pawn: response.data.data,
              initialValues: initialValues,
              fields: fields,
              fieldDefs: fieldDefs
            });
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "_onSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values) {
        var _this$props2, includeUserFields, onSuccess, pawnId, pawnHash, isUsernameEmail, response, submissionErrors, _i, _Object$keys, key;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, includeUserFields = _this$props2.includeUserFields, onSuccess = _this$props2.onSuccess, pawnId = _this$props2.pawnId, pawnHash = _this$props2.pawnHash;
              isUsernameEmail = _this.state.isUsernameEmail;
              values.pawnId = pawnId;
              values.pawnHash = pawnHash;
              if (isUsernameEmail && includeUserFields && values.email) {
                values.username = values.email;
              } else {
                delete values.username;
              }
              _context2.next = 7;
              return _cccisdAxios["default"].put(Boilerplate.route('api.nexus.pawn.update', {
                pawn: pawnId
              }), values);
            case 7:
              response = _context2.sent;
              if (!(response.data.status === 'success')) {
                _context2.next = 12;
                break;
              }
              if (onSuccess) {
                onSuccess();
              } else {
                window.location = Boilerplate.url(Fortress.settings.config.after_login_url);
              }
              _context2.next = 20;
              break;
            case 12:
              if (!(response.data.status === 'error')) {
                _context2.next = 19;
                break;
              }
              submissionErrors = {};
              for (_i = 0, _Object$keys = Object.keys(response.data.errors); _i < _Object$keys.length; _i++) {
                key = _Object$keys[_i];
                submissionErrors[key] = Array.isArray(response.data.errors[key]) ? response.data.errors[key].join(', ') : response.data.errors;
              }
              if (isUsernameEmail && submissionErrors.username) {
                submissionErrors.email = submissionErrors.username;
              }
              return _context2.abrupt("return", Promise.reject(submissionErrors));
            case 19:
              console.error(response);
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    return _this;
  }
  _createClass(ProfileUpdateForm, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
        initialValues = _this$state.initialValues,
        loading = _this$state.loading,
        fields = _this$state.fields,
        fieldDefs = _this$state.fieldDefs,
        pawn = _this$state.pawn;
      var _this$props3 = this.props,
        buttonLabel = _this$props3.buttonLabel,
        formName = _this$props3.formName;
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: loading
      }, /*#__PURE__*/_react["default"].createElement(_form["default"], {
        onSubmit: this._onSubmit,
        form: formName || 'profileUpdateForm',
        fields: fields,
        initialValues: initialValues,
        fieldDefs: fieldDefs,
        pawn: pawn,
        buttonLabel: buttonLabel
      }));
    }
  }]);
  return ProfileUpdateForm;
}(_react["default"].Component);
_defineProperty(ProfileUpdateForm, "propTypes", {
  onSuccess: _propTypes["default"].func,
  formName: _propTypes["default"].string,
  pawnId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,
  pawnHash: _propTypes["default"].string.isRequired,
  includeUserFields: _propTypes["default"].bool,
  includePawnFields: _propTypes["default"].bool,
  includePasswordFields: _propTypes["default"].bool,
  includeNotificationFields: _propTypes["default"].bool,
  buttonLabel: _propTypes["default"].string,
  showTheseProfileDataFields: _propTypes["default"].object // array of data field handles to include in profile update
});
_defineProperty(ProfileUpdateForm, "defaultProps", {
  includeUserFields: true,
  includePawnFields: true,
  includePasswordFields: true,
  includeNotificationFields: true,
  buttonLabel: 'Update Profile',
  showTheseProfileDataFields: {}
});